module.exports = __webpack_public_path__ + "static/media/rule-book.242386b9.png";